module.exports = __webpack_public_path__ + "img/rank2.c05ffba8.png";